import module from "./Home/fdcalculator.js"
import bankDetails from "./rewards/bank-details.js"
import redeem from "./rewards/redeem.js"


setTimeout(function (e) {
    redeem()
    // module.fdCalculator()
    module.rangeSlider()
    bankDetails()
},2000)
